<template>
  <header class="app-header">
    <div class="app-header__inner">
      <router-link :to="{name:'Home'}" class="app-header__brand">
        <span class="app-header__logo"><img src="@/assets/logo-jersey.jpeg" alt="SCL"></span>
        <span class="app-header__name">SCL<small>Controle Leiteiro</small></span>
      </router-link>

      <nav class="app-header__nav">
        <ul>
          <li v-for="(nav,i) in visibleRoutes" :key="i" :class="{active: isActive(nav)}">
            <span class="app-header__link" @click="redirectPath(nav)">
              {{nav.title}}
              <i v-if="nav.subRoutes" class="mdi mdi-chevron-down"></i>
            </span>
            <!-- Se o nav tiver sublinks irá construír o dropdown -->
            <div v-if="nav.subRoutes" class="app-header__menu">
              <router-link 
                v-for="(subLink, i) in nav.subRoutes" 
                :key="i" 
                :to="{name:subLink.path}"
              >
                {{subLink.name}}
              </router-link>
            </div>
          </li>
        </ul>
      </nav>

      <div class="app-header__actions">
        <button
          v-if="canShowEvent"
          type="button"
          class="app-header__icon"
          aria-label="Calendário"
          v-tooltip.bottom="{content:'Calendário'}"
          @click="$router.push({name:'Calender'})"
        >
          <i class="mdi mdi-calendar-range"></i>
        </button>

        <!-- Sino ocultado provisoriamente: sem funcionalidade de notificacao ainda (decisao Altamir 18/09) -->

        <span class="app-header__avatar">{{userInitial}}</span>
        <b-dropdown right id="dropdown-user" :text="loggedUser.attributes ? loggedUser.attributes.name : ''" variant="text" class="m-0 p-0">
          <b-dropdown-item
            class="pr-10 pl-10 b-drop-options"
            variant="text"
            @click="$router.push({name:'Profile'})"
          >
            <i
              class="mdi mdi-account pr-2"
              style="font-size:1.4rem"
            ></i>
            Meu Perfil
          </b-dropdown-item>

          <b-dropdown-item 
            class="pr-10 pl-10 b-drop-options close"
            variant="text"
            @click="actionLogout"
          >
            <i 
              class="mdi mdi-power pr-2" 
              style="font-size:1.7rem;"
            ></i>
            Sair
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import {BDropdown, BDropdownItem} from "bootstrap-vue";
import { mapActions } from 'vuex';
import { visibleNav } from "@/router/navigation";
export default {
  name:"TheHeader",
  props:{
    loggedUser:Object,
    url:String
  },
  components:{
    BDropdown,
    BDropdownItem
  },
  computed: {
    visibleRoutes() {
      return visibleNav(this.loggedUser);
    },
    userInitial() {
      const name = ((this.loggedUser.attributes || {}).name || "").trim();
      return name ? name[0].toUpperCase() : "?";
    },
    canShowEvent() {
      if(this.loggedUser.roles) {
        const can_create = this.loggedUser.roles.find(e => e.name === "service.create");
        if(can_create) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("login", ["actionLogout"]),
    // menu da tela atual: submenu com a rota aberta, ou Relatórios (as telas de relatório não ficam em /reports)
    isActive(nav) {
      if(nav.subRoutes) return nav.subRoutes.some(sub => sub.path === this.$route.name);
      return this.$route.path === nav.path || String(this.$route.meta.title || "").startsWith(nav.title);
    },
    redirectPath(nav) {
      if(nav.path) {
        this.$router.push(nav.path);
      }
    }
  }
}
</script>

<style scoped>
  .app-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: var(--header-height);
    z-index: 100;
    color: white;
    background: linear-gradient(90deg, #d99c06 0%, #c98d00 100%);
    box-shadow: 0 2px 12px rgba(16, 24, 40, .14);
  }
  .app-header__inner {
    height: 100%;
    width: calc(100% / 12 * 11);
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 28px;
  }
  .app-header__brand {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
  }
  .app-header__logo {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0 0 0 3px rgba(255, 255, 255, .35);
  }
  .app-header__logo img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .app-header__name {
    display: flex;
    flex-direction: column;
    line-height: 1.05;
    font-weight: 800;
    font-size: 1.1rem;
    letter-spacing: .03em;
    color: white;
  }
  .app-header__name small {
    font-weight: 700;
    font-size: .68rem;
    letter-spacing: .06em;
    text-transform: uppercase;
  }
  .app-header__nav {
    flex: 1;
    height: 100%;
  }
  .app-header__nav ul {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
  }
  .app-header__nav li {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    list-style: none;
  }
  .app-header__link {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 8px 14px;
    border-radius: 999px;
    font-size: .98rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color .15s ease;
  }
  li:hover .app-header__link {
    background: rgba(0, 0, 0, .1);
  }
  li.active .app-header__link {
    background: rgba(0, 0, 0, .18);
  }
  /* dropdown do menu */
  /* aparece por transição (opacidade/visibilidade): a animação com display deixava o menu
     preso semitransparente, com o conteúdo da página aparecendo por cima */
  .app-header__menu {
    display: flex;
    visibility: hidden;
    opacity: 0;
    transform: translateY(-4px);
    transition: opacity .14s ease, transform .14s ease, visibility 0s linear .14s;
    flex-direction: column;
    position: absolute;
    top: calc(100% - 8px);
    left: 0;
    min-width: 230px;
    padding: 8px;
    background: white;
    border: 1px solid var(--line);
    border-radius: 12px;
    box-shadow: 0 12px 32px rgba(16, 24, 40, .16);
    z-index: 900;
  }
  li:hover .app-header__menu {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
    transition: opacity .14s ease, transform .14s ease, visibility 0s;
  }
  .app-header__menu a {
    padding: 9px 12px;
    border-radius: 8px;
    text-decoration: none;
    font-size: .92rem;
    font-weight: 500;
    color: var(--ink) !important;
    transition: background-color .12s ease;
  }
  .app-header__menu a:hover {
    background: var(--jersey-yellow-soft);
  }
  .app-header__menu a.router-link-active {
    color: var(--jersey-yellow-dark) !important;
    font-weight: 700;
  }
  /* ações à direita */
  .app-header__actions {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .app-header__icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.5rem;
    transition: background-color .15s ease;
  }
  .app-header__icon:hover {
    background: rgba(0, 0, 0, .1);
  }
  .app-header__avatar {
    width: 34px;
    height: 34px;
    margin-left: 6px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--medium-blue);
    color: white;
    font-weight: 700;
    font-size: .9rem;
  }
  ::v-deep #dropdown-user .btn {
    color: white !important;
    font-weight: 600;
    padding-left: 4px;
  }
  ::v-deep #dropdown-user .dropdown-item {
    padding: 8px 18px !important;
  }
  ::v-deep #dropdown-user .dropdown-item i {
    width: 26px;
    font-size: 1.3rem !important;
    padding-right: 6px !important;
  }
  @media (max-width: 1100px) {
    .app-header__inner {
      gap: 14px;
    }
    .app-header__name small {
      display: none;
    }
    .app-header__link {
      padding: 8px 10px;
      font-size: .92rem;
    }
  }
  @media (max-width: 760px) {
    .app-header__inner {
      width: 100%;
      padding: 0 10px;
      gap: 8px;
    }
    .app-header__name {
      display: none;
    }
    .app-header__nav ul {
      gap: 0;
    }
    .app-header__link {
      padding: 6px 8px;
      font-size: .82rem;
    }
    .app-header__icon {
      width: 34px;
      height: 34px;
      font-size: 1.25rem;
    }
    .app-header__avatar {
      margin-left: 0;
    }
    ::v-deep #dropdown-user .btn {
      font-size: 0;
      padding: 0 4px;
    }
    ::v-deep #dropdown-user .btn::after {
      font-size: 1rem;
    }
  }
  /* celulares comuns (360–480px): tudo cabe, inclusive o menu do usuário (Meu Perfil / Sair) */
  @media (max-width: 480px) {
    .app-header__inner {
      padding: 0 6px;
      gap: 4px;
    }
    .app-header__logo {
      width: 36px;
      height: 36px;
    }
    .app-header__logo img {
      width: 32px;
      height: 32px;
    }
    .app-header__link {
      padding: 4px 6px;
      font-size: .74rem;
      line-height: 1.1;
      text-align: center;
    }
    .app-header__link i {
      display: none;
    }
    .app-header__icon {
      width: 30px;
      height: 30px;
      font-size: 1.1rem;
    }
    .app-header__avatar {
      width: 28px;
      height: 28px;
      font-size: .8rem;
    }
    .app-header__menu {
      min-width: 180px;
    }
    .app-header__nav li:last-child .app-header__menu,
    .app-header__nav li:nth-child(2) .app-header__menu {
      left: auto;
      right: 0;
    }
  }
</style>
